import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MaterialSharedModule } from '../ui-modules/material-shared.module';
import { TranslocoLoaderModule } from 'src/app/core/transloco/transloco.module';
import { PrimengSharedModule } from '../ui-modules/primeng-shared.module';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    MaterialSharedModule,
    TranslocoLoaderModule,
    PrimengSharedModule,
  ],
  exports: [HeaderComponent, FooterComponent],
  providers: [DialogService],
})
export class SharedComponentsModule {}
